import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-223d3494"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mt-3 mb-5" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row align-items-center mx-1" }
const _hoisted_4 = { class: "col-1 ps-0" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "fw-bold fs-5 mb-2" }
const _hoisted_8 = {
  key: 0,
  class: "row align-items-center mx-1 mt-3 pt-2 border-top"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, " セクション ", -1))
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "me-2" }, "種別:", -1))
const _hoisted_13 = { class: "me-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "me-2" }, "質問:", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("質問無し")

import { ref } from 'vue'
import { ConciergeCategory, ConciergeSection } from '@/plugins/nicotto'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConciergeHeaderQuestion',
  props: {
    category: null,
    section: null
  },
  setup(__props: any) {

const props = __props as {
  category: ConciergeCategory,
  section?: ConciergeSection
}



const iconSrc = ref(props.category.iconUrl || '/img/noimage.png')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: iconSrc.value,
            class: "category-icon"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(__props.category.name), 1),
          _createElementVNode("div", null, _toDisplayString(__props.category.description), 1)
        ])
      ]),
      (__props.section)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("dl", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("dd", _hoisted_13, _toDisplayString(__props.section.name), 1),
                _hoisted_14,
                _createElementVNode("dd", null, [
                  _createTextVNode(_toDisplayString(__props.section.question), 1),
                  (!__props.section.question)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_15
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})